import "./ChooseRestaurant.scss"

import {
  BACK_BUTTON,
  RESTAURANT_SELECT_LABEL,
  GO_BACK_FROM_RESTAURANTS,
  GO_BACK_CONTENT,
  TAKE_ME_BACK,
  CANCEL,
} from "../../constants/messages"
import { Col, Row, Modal } from "antd"
import {
  FIREBASE_STATE_KEYS,
  FirebaseContext,
  FirebaseService,
} from "../../firebase"
import React, { useState, useEffect } from "react"
import {
  getRestaurants,
  suggestRestaurant,
  emptyDeliveryDotComCart,
} from "../../redux/actionCreators/planDinnner"

import { ActivityIndicator } from "../ActivityIndicator"
import { ArrowLeftOutlined } from "@ant-design/icons"
import MatchingRestaurantsClosedHeader from "./MatchingRestaurantsClosedHeader"
import NoRestaurantsHeader from "./NoRestaurantsHeader"
import { PageHeader } from "../../molecules/PageHeader"
import PartnerAway from "../../components/PartnerAway/PartnerAway"
import RestaurantList from "../RestaurantList/RestaurantList"
import RestaurantsMatchedHeader from "./RestaurantsMatchedHeader"
import WaitingForPartnerAddress from "./WaitingForPartnerHeader"
import _ from "../../utils/lodashUtils"
import { connect } from "react-redux"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import { isPartnerAway, getPartnerNameorNickName } from "../../utils/helpers"
import { CustomModal, TextTag, Button } from "../../atoms"
import { CUSTOM_EVENTS, SUGGESTION_STATES } from "../../constants/commons"
import { emitter } from "../../utils/emitter"
import { usePrevious } from "common-custom-hooks"

const ChooseRestaurant = props => {
  const {
    user,
    history,
    partners,
    getRestaurants,
    fetchPartnerDetails,
    restaurants,
    fetchingRestaurantData,
    emptyDeliveryDotComCart,
  } = props

  const fbContext = React.useContext(FirebaseContext)
  const { partnerState, userState, dateState } = fbContext
  const combinedOrderNotify = _.get(dateState, "notifyCombineOrder")
  const [restaurantList, setRestaurantList] = useState([])
  const [backModalVisibility, setBackModalVisibility] = useState(false)
  const userId = _.get(user, "uuid")
  const setRestaurantListValue = restaurantList => {
    setRestaurantList(restaurantList)
  }
  const combineOrderModal = () => {
    emitter.fire(CUSTOM_EVENTS.SHOW_COMBINE_ORDER_MODAL, [])
  }
  useEffect(() => {
    if (userId === combinedOrderNotify) {
      combineOrderModal()
    }
  }, [combinedOrderNotify])
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  const showPartnerAway =
    isPartnerAway(partnerScreen, partnerOnline) && !fetchingRestaurantData

  let userDetailsFirebase = userState ? userState : { userDetails: user }
  let partnerDetailsFirebase =
    partners && partners.partner2
      ? partnerState
        ? partnerState
        : { userDetails: partners.partner2 }
      : userDetailsFirebase

  //updated partner address from the firebase details of both the user and partner
  // TODO: Check if we need this code or not
  let userNameValue = user && user.username
  const partnerAddress =
    _.get(partnerDetailsFirebase.userDetails, "username") === userNameValue
      ? _.get(userDetailsFirebase.userDetails, "address")
      : _.get(partnerDetailsFirebase.userDetails, "address")

  const partnerAddressChange = _.get(userState, "notifyAddressChange")
  const removeAddressChange = () => {
    FirebaseService.delete(
      `${FirebaseService.getDefaultPath()}${userId}/${
        FIREBASE_STATE_KEYS.NOTIFY_ADDRESS_CHANGE
      }`
    )
  }

  // Refresh the list of restaurants if the partner has updated the address
  React.useEffect(() => {
    fetchPartnerDetails()
    getRestaurants({ onSuccess: setRestaurantListValue })
    if (partnerAddressChange) {
      removeAddressChange()
    }
  }, [partnerAddressChange])

  const userFirebaseAddress = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.ADDRESS}.${FIREBASE_STATE_KEYS.USER_ADDRESS}`
  )
  const partnerFirebaseAddress = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.ADDRESS}.${FIREBASE_STATE_KEYS.USER_ADDRESS}`
  )

  // Refresh the list of restaurants if there is a change in user/partner's address.
  React.useEffect(() => {
    getRestaurants({ onSuccess: setRestaurantListValue })
  }, [userFirebaseAddress, partnerFirebaseAddress])

  const planADate = _.get(dateState, "planADate", false)
  React.useEffect(() => {
    if (planADate) {
      FirebaseService.delete(
        `${FirebaseService.getDefaultPath()}${user.uuid}/${
          FIREBASE_STATE_KEYS.BACK_TO_PLANNING
        }`
      )
      emitter.fire(CUSTOM_EVENTS.HIDE_PARTNER_BACK_TO_PLAN_A_DATE_MODAL, [])
    }
  }, [planADate])

  /* Back to Plan a date screen Modal Emitter Registry and toggling modal */

  const toggleBackModal = value => () => {
    setBackModalVisibility(value)
  }

  React.useEffect(() => {
    const showBackModalListener = emitter.addListener(
      CUSTOM_EVENTS.SHOW_BACK_TO_PLAN_A_DATE_SCREEN_MODAL,
      toggleBackModal(true)
    )
    const hideBackModalListener = emitter.addListener(
      CUSTOM_EVENTS.HIDE_BACK_TO_PLAN_A_DATE_SCREEN_MODAL,
      toggleBackModal(false)
    )
    return () => {
      showBackModalListener.remove()
      hideBackModalListener.remove()
    }
  }, [])

  const openRestaurants = Object.keys(restaurants).reduce(function(
    filtered,
    key
  ) {
    if (
      _.get(restaurants, [key, "order_time", "open"]) &&
      _.get(restaurants, [key, "order_time", "delivery"])
    )
      filtered[key] = restaurants[key]

    return filtered
  },
  {})

  const openRestaurantsCount = Object.keys(openRestaurants).length
  const allRestaurantsCount = Object.keys(restaurants).length
  const partnerName = getPartnerNameorNickName(partnerState)
  const partnerUuid = _.get(props.usersPartner, "uuid")
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )

  //Text content which says how many restaurnats are oprn in common
  function renderHeader() {
    if (partnerAddress && partnerAddress.user_address) {
      if (allRestaurantsCount) {
        if (openRestaurantsCount)
          return (
            <RestaurantsMatchedHeader
              restaurantsCount={openRestaurantsCount}
              restaurantList={restaurantList}
              setRestaurantList={setRestaurantListValue}
            />
          )
        // when address have any common restaurants, and all are closed
        else
          return (
            <MatchingRestaurantsClosedHeader
              restaurantsCount={allRestaurantsCount}
            />
          )
      } // when address do not have any common restaurants
      else
        return (
          <NoRestaurantsHeader
            restaurantList={restaurantList}
            setRestaurantList={setRestaurantListValue}
          />
        )
    } else {
      //wait for partner to enter address
      return <WaitingForPartnerAddress />
    }
  }
  const goBackForUser = async () => {
    Modal.destroyAll()
    emitter.fire(CUSTOM_EVENTS.SHOW_BACK_TO_PLAN_A_DATE_SCREEN_MODAL, [])
  }
  const suggestedRestaurant = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
    {}
  )
  // TODO: Check if we need to evaluate with previousSuggestedRestaurant or not
  const partnerBackToPlanningModal = _.get(
    userState,
    FIREBASE_STATE_KEYS.BACK_TO_PLANNING
  )
  const showPartnerBackToPlanningModal =
    partnerBackToPlanningModal && partnerBackToPlanningModal === user.uuid
  const previousSuggestedRestaurant = usePrevious(suggestedRestaurant)
  const showAcceptedRestaurantModal =
    suggestedRestaurant[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.ACCEPTED
  const disableBackButton =
    showPartnerAway ||
    backModalVisibility ||
    (showAcceptedRestaurantModal &&
      !_.get(
        acceptedRestaurant,
        FIREBASE_STATE_KEYS.RESET_RESTAURANT,
        false
      )) ||
    showPartnerBackToPlanningModal
  return (
    <div id="ChooseRestaurant">
      <div id="dinnerPlanSection">
        <div id="dinnerPlan">
          {showPartnerAway && <PartnerAway {...props} />}
          {fetchingRestaurantData ? (
            <div>
              <ActivityIndicator styles={{ fontSize: "3em" }} />
            </div>
          ) : (
            <div>
              <Row id="KitchenText">
                <Col>
                  <PageHeader
                    onClick={goBackForUser}
                    btnText={BACK_BUTTON}
                    disabled={disableBackButton}
                    icon={<ArrowLeftOutlined />}
                    headerText={RESTAURANT_SELECT_LABEL}
                  />
                </Col>
              </Row>
              {renderHeader()}
              <div>
                <RestaurantList
                  isSuggestRequired={true}
                  showClosed={true}
                  isPartnerAway={showPartnerAway}
                  restaurantsList={restaurantList}
                  showPartnerBackToPlanningModal={
                    showPartnerBackToPlanningModal
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <CustomModal
        title={GO_BACK_FROM_RESTAURANTS}
        visible={backModalVisibility && !showPartnerBackToPlanningModal}
        keyboard={false}
        footer={[
          <Button
            className="save-btn"
            onClick={async () => {
              if (acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID])
                emptyDeliveryDotComCart(
                  acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]
                )
              // Take both user and partner back to plan date
              FirebaseService.patch(
                {
                  [FIREBASE_STATE_KEYS.BACK_TO_PLANNING]: partnerUuid,
                },
                `${FirebaseService.getDefaultPath()}${partnerUuid}`
              )
              FirebaseService.patch(
                {
                  [FIREBASE_STATE_KEYS.PLAN_A_DATE]: false,
                },
                `${FirebaseService.getDefaultPath()}`
              )
              emitter.fire(
                CUSTOM_EVENTS.HIDE_BACK_TO_PLAN_A_DATE_SCREEN_MODAL,
                []
              )
              FirebaseService.setActiveRoute("/plan-new-date")
              history.push("/plan-new-date")
            }}
          >
            {TAKE_ME_BACK}
          </Button>,
          <Button
            key="cancel"
            btnType="bordered"
            onClick={() =>
              emitter.fire(
                CUSTOM_EVENTS.HIDE_BACK_TO_PLAN_A_DATE_SCREEN_MODAL,
                []
              )
            }
          >
            {CANCEL}
          </Button>,
        ]}
      >
        <TextTag>{GO_BACK_CONTENT(partnerName)}</TextTag>
      </CustomModal>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    suggestedRestaurant: state.planDinner.restaurantSuggested,
    suggested: state.planDinner.suggested,
    accepted: state.planDinner.acceptSuggestion,
    declined: state.planDinner.declinedSuggestion,
    changeRestaurant: state.planDinner.changeRestaurant,
    user: state.auth.user,
    usersPartner: state.auth.partner,
    nickName: state.invitePeople.nickName,
    partners: state.invitePeople.partnerDetails,
    restaurants: _.get(state, "planDinner.restaurants", {}),
    fetchingRestaurantData: state.loadingState.fetchingRestaurantData,
  }
}

export default connect(mapStateToProps, {
  suggestRestaurant,
  getRestaurants,
  invitePartnerToChat,
  fetchPartnerDetails,
  emptyDeliveryDotComCart,
})(ChooseRestaurant)
